// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.making-process-title h1 {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size: 32px;
    line-height: 38px;
    letter-spacing: 1px;
    color: #000000;
    margin:0px;
}

.making-process {
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* margin:50px 0px; */
    margin-top: 40px;
}

.making-process-main {
    display: grid;
    grid-template-columns: 1fr 2fr;
    align-items: center;
    justify-content: center;

}

.final-product-image img{
    
    height:500px;
    /* margin:0px -150px; */
    margin-left:-120px;
    margin-right: -200px;
    margin-top: 50px;
   
}

.making-process-process{
    margin:0px;
}


.making-process-process ul {
    display:flex;
    flex-direction: column;
    list-style-type: none;
    justify-content: space-evenly;
    align-items: center;
    margin: 10px;

}


.making-process-section-1{
    display: flex;
    flex-direction: row;
}

.making-process-section-2{
    display: flex;
    flex-direction: row;
}
.making-process-card {
    width: 40%;
    height:100%;
    display:flex;
    flex-direction: column;
    align-items: center;
    padding:10px;
    
    
}




.making-process-card p {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    color:#444444;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1px;
    text-align: justify;
   
}

.making-process-card img{
   width:220px;
   height:150px;
   margin: 0px;
   
   
}

.making-process-image img{
    width:100px;
    
}

.arrows-section-1{
    position: relative;
    margin-top: 80px;
    display: flex;
    flex-direction: column;
    padding:20px;
}

.process-arrow1{
    margin-bottom: 60px;
    width:60px;
}

.process-arrow2{
    width:60px;
    
    /* margin-right: 30px; */
}

.process-arrow3{
    width:60px;
    
}

.arrows-section-2{
    position:relative;
    margin-top:120px;
    padding:20px;
}


.making-process-background-image{
    background-color: #FFEBEE;
    width:100vw;
    height:100vh;
    margin-left: -40px;
 
}

@media screen and (max-width:768px){

    .making-process-main {
            display: flex;
            flex-direction: column;
            align-items: center;
    
        }
        .final-product-image img {
    
            width: 100%;
        }
        .final-product-image img {
    
            height: auto;
            /* margin:0px -150px; */
            margin-left: 0px;
            margin-right: 0px;
    
        }
    .making-process-title h1 {
            font-family: 'Raleway', sans-serif;
            font-weight: 700;
            font-size: 22px;
            line-height: 30px;
            letter-spacing: 1px;
            color: #000000;
            margin: 0px;
        }

        .making-process-process ul {
            display: flex;
            flex-direction: column;
            list-style-type: none;
            justify-content: space-evenly;
            align-items: center;
            margin: 10px;
            padding-left: 0px;
    
        }
        .making-process-section-1 {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .making-process-section-2 {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .making-process-card {
            width: 70%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 10px;
    
    
        }
        .arrows-section-1 {
            position: relative;
            margin-top: 0px;
        }
        .process-arrow1 {
            margin-bottom: 0px;
            width: 60px;
            display: none;
        }
    
        .process-arrow2 {
            width: 60px;
            display: none;
        }

        .process-arrow3 {
            width: 60px;
            display: none;
        }
    
        .arrows-section-2 {
            position: relative;
            margin-top: 0px;
        }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/MakingProcess.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;;IAEI,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;;AAEpB;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;;AAEhB;;;AAGA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;;;AAGhB;;;;;AAKA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;;AAEvB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,WAAW;;;AAGd;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,UAAU;;IAEV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;;AAEd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;;AAEtB;;AAEA;;IAEI;YACQ,aAAa;YACb,sBAAsB;YACtB,mBAAmB;;QAEvB;QACA;;YAEI,WAAW;QACf;QACA;;YAEI,YAAY;YACZ,uBAAuB;YACvB,gBAAgB;YAChB,iBAAiB;;QAErB;IACJ;YACQ,kCAAkC;YAClC,gBAAgB;YAChB,eAAe;YACf,iBAAiB;YACjB,mBAAmB;YACnB,cAAc;YACd,WAAW;QACf;;QAEA;YACI,aAAa;YACb,sBAAsB;YACtB,qBAAqB;YACrB,6BAA6B;YAC7B,mBAAmB;YACnB,YAAY;YACZ,iBAAiB;;QAErB;QACA;YACI,aAAa;YACb,sBAAsB;YACtB,mBAAmB;QACvB;QACA;YACI,aAAa;YACb,sBAAsB;YACtB,mBAAmB;QACvB;;QAEA;YACI,UAAU;YACV,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,aAAa;;;QAGjB;QACA;YACI,kBAAkB;YAClB,eAAe;QACnB;QACA;YACI,kBAAkB;YAClB,WAAW;YACX,aAAa;QACjB;;QAEA;YACI,WAAW;YACX,aAAa;QACjB;;QAEA;YACI,WAAW;YACX,aAAa;QACjB;;QAEA;YACI,kBAAkB;YAClB,eAAe;QACnB;AACR","sourcesContent":[".making-process-title h1 {\n    font-family: 'Raleway', sans-serif;\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 38px;\n    letter-spacing: 1px;\n    color: #000000;\n    margin:0px;\n}\n\n.making-process {\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    /* margin:50px 0px; */\n    margin-top: 40px;\n}\n\n.making-process-main {\n    display: grid;\n    grid-template-columns: 1fr 2fr;\n    align-items: center;\n    justify-content: center;\n\n}\n\n.final-product-image img{\n    \n    height:500px;\n    /* margin:0px -150px; */\n    margin-left:-120px;\n    margin-right: -200px;\n    margin-top: 50px;\n   \n}\n\n.making-process-process{\n    margin:0px;\n}\n\n\n.making-process-process ul {\n    display:flex;\n    flex-direction: column;\n    list-style-type: none;\n    justify-content: space-evenly;\n    align-items: center;\n    margin: 10px;\n\n}\n\n\n.making-process-section-1{\n    display: flex;\n    flex-direction: row;\n}\n\n.making-process-section-2{\n    display: flex;\n    flex-direction: row;\n}\n.making-process-card {\n    width: 40%;\n    height:100%;\n    display:flex;\n    flex-direction: column;\n    align-items: center;\n    padding:10px;\n    \n    \n}\n\n\n\n\n.making-process-card p {\n    font-family: 'Poppins', sans-serif;\n    font-weight: 500;\n    color:#444444;\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: 1px;\n    text-align: justify;\n   \n}\n\n.making-process-card img{\n   width:220px;\n   height:150px;\n   margin: 0px;\n   \n   \n}\n\n.making-process-image img{\n    width:100px;\n    \n}\n\n.arrows-section-1{\n    position: relative;\n    margin-top: 80px;\n    display: flex;\n    flex-direction: column;\n    padding:20px;\n}\n\n.process-arrow1{\n    margin-bottom: 60px;\n    width:60px;\n}\n\n.process-arrow2{\n    width:60px;\n    \n    /* margin-right: 30px; */\n}\n\n.process-arrow3{\n    width:60px;\n    \n}\n\n.arrows-section-2{\n    position:relative;\n    margin-top:120px;\n    padding:20px;\n}\n\n\n.making-process-background-image{\n    background-color: #FFEBEE;\n    width:100vw;\n    height:100vh;\n    margin-left: -40px;\n \n}\n\n@media screen and (max-width:768px){\n\n    .making-process-main {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n    \n        }\n        .final-product-image img {\n    \n            width: 100%;\n        }\n        .final-product-image img {\n    \n            height: auto;\n            /* margin:0px -150px; */\n            margin-left: 0px;\n            margin-right: 0px;\n    \n        }\n    .making-process-title h1 {\n            font-family: 'Raleway', sans-serif;\n            font-weight: 700;\n            font-size: 22px;\n            line-height: 30px;\n            letter-spacing: 1px;\n            color: #000000;\n            margin: 0px;\n        }\n\n        .making-process-process ul {\n            display: flex;\n            flex-direction: column;\n            list-style-type: none;\n            justify-content: space-evenly;\n            align-items: center;\n            margin: 10px;\n            padding-left: 0px;\n    \n        }\n        .making-process-section-1 {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n        }\n        .making-process-section-2 {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n        }\n\n        .making-process-card {\n            width: 70%;\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            padding: 10px;\n    \n    \n        }\n        .arrows-section-1 {\n            position: relative;\n            margin-top: 0px;\n        }\n        .process-arrow1 {\n            margin-bottom: 0px;\n            width: 60px;\n            display: none;\n        }\n    \n        .process-arrow2 {\n            width: 60px;\n            display: none;\n        }\n\n        .process-arrow3 {\n            width: 60px;\n            display: none;\n        }\n    \n        .arrows-section-2 {\n            position: relative;\n            margin-top: 0px;\n        }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
